import CryptoJS from "crypto-js";
const AES_KEY = 'bpm369!@#Authine';
const iv_KEY = "0123456789ABCDEF";
export default {
    //随机生成指定数量的16进制key
    generatekey(num) {
        let library = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let key = "";
        for (var i = 0; i < num; i++) {
            let randomPoz = Math.floor(Math.random() * library.length);
            key += library.substring(randomPoz, randomPoz + 1);
        }
        return key;
    },
    //加密
    encrypt(word, keyStr = "") {
        keyStr = keyStr ? keyStr : AES_KEY; //判断是否存在ksy，不存在就用定义好的key
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        var srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
        return encrypted.toString();
    },
    //解密
    decrypt(word, keyStr = "") {
        keyStr = keyStr ? keyStr : AES_KEY;
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },
    //加密
    encrypt_iv(word, keyStr = "", iv = "") {
        keyStr = keyStr ? keyStr : AES_KEY; //判断是否存在ksy，不存在就用定义好的key
        iv = iv ? iv : iv_KEY; //判断是否存在iv，不存在就用定义好的iv
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        var srcs = CryptoJS.enc.Utf8.parse(word);
        var IV = CryptoJS.enc.Utf8.parse(iv);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
        return encrypted.toString();
    },
    //解密
    decrypt_iv(word, keyStr = "", iv = "") {
        keyStr = keyStr ? keyStr : AES_KEY;
        iv = iv ? iv : iv_KEY; //判断是否存在iv，不存在就用定义好的iv
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        var IV = CryptoJS.enc.Utf8.parse(iv);
        var decrypt = CryptoJS.AES.decrypt(word, key, { iv: IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },
    aesEncrypt_HEX(message, key, iv) {
        //debugger;
        if (!message)
            return "";
        var ciphertext = CryptoJS.AES.encrypt(message, CryptoJS.enc.Hex.parse(key).toString(), {
            iv: CryptoJS.enc.Hex.parse(iv).toString(),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return ciphertext.toString();
    },
    aesDecrypt_HEX(ciphertext, key, iv) {
        //debugger;
        if (!ciphertext)
            return "";
        var decrypted = CryptoJS.AES.decrypt(ciphertext, CryptoJS.enc.Hex.parse(key).toString(), {
            iv: CryptoJS.enc.Hex.parse(iv).toString(),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
};
